// Outcome-flock collapsible sections shown at the bottom of SheepFlocksView.
// Thin sheep wrapper over the shared RuminantOutcomeSections component.
import {RuminantOutcomeSections} from '../cattle/ruminantPresentation.js';

type OutcomeSheep = {
  id: string;
  flock: string;
  tag?: string | number | null;
  sex?: string | null;
  breed?: string | null;
  death_date?: string | null;
  sale_date?: string | null;
};

type SheepCollapsibleOutcomeSectionsProps = {
  sheep: OutcomeSheep[];
  FLOCK_LABELS: Record<string, string>;
  OUTCOMES: readonly string[];
  fmt: (iso: string | null | undefined) => string;
  setStatusFilter: (flock: string) => void;
  onSheepClick?: (sheep: OutcomeSheep) => void;
};

const getSheepOutcomeGroup = (row: OutcomeSheep) => row.flock;

const SheepCollapsibleOutcomeSections = ({
  sheep,
  FLOCK_LABELS,
  OUTCOMES,
  fmt,
  setStatusFilter,
  onSheepClick,
}: SheepCollapsibleOutcomeSectionsProps) => (
  <RuminantOutcomeSections
    rows={sheep}
    getGroup={getSheepOutcomeGroup}
    groupLabels={FLOCK_LABELS}
    outcomes={OUTCOMES}
    stateKeyPrefix="sheep"
    rowIdPrefix="sheep-"
    fmt={fmt}
    setStatusFilter={setStatusFilter}
    onRowClick={onSheepClick}
  />
);

export default SheepCollapsibleOutcomeSections;
